export default __webpack_public_path__ + "static/physalisdipped-9a1c7e85f490385e4c7c5e71fa1519dd.png";